import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GeneralLabelService } from 'src/raksme/services/general-label/label.service';
import { error } from 'protractor';
import { Router } from '@angular/router';
import { WidgetsService } from 'src/raksme/services/widgets/widgets.service';
import { resolveLanguageUrls } from './language-switcher/language-routes';

@Component({
  selector: 'raksme-header',
  templateUrl: './raksme.headerView.html',
  styleUrls: ['./raksme.headerStyle.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  title = 'rak-sme';
  public generalLabels: any = [];
  public subscription: Subscription[] = [];
  public lang: string;
  public settingsData: any = [];
  constructor(private labelService: GeneralLabelService, private router: Router, private widgetService: WidgetsService){}
  ngOnInit(): void{
    const url = this.router.url;
      
    
    // Exact segment match, not a substring test: url.includes('/ar') reports
    // Arabic for /business-directory/12/architects. resolveLanguageUrls is the
    // same function the language switcher uses.
    //
    // The RAKSME_LANG writes that were here are gone with the redirect that
    // read them (see raksme.mainComponent.ts) - a stored preference that
    // rewrites the address bar makes a shared link mean different things to
    // different people.
    this.lang = resolveLanguageUrls(this.router.url).lang;

    this.subscription.push(
      this.labelService.getLabels('general-label/'+this.lang).subscribe(
        res => {
          this.generalLabels = res;
        },
        error => {
          console.log(error);
        }
      )
    );
    
    this.subscription.push(
      this.widgetService.getSettings('website-settings/'+this.lang).subscribe(
        res => {
          this.settingsData = res;
          
        },
        error => console.log(error)
      )
    )

  }

  ngOnDestroy():void {
    this.subscription.forEach(sub => {
      sub.unsubscribe();
    })
  }
  
}
